import React from 'react';

import { BaseIconProps } from '.';

export const NewWindow = ({ fill }: BaseIconProps) => (
  <g transform="matrix(74.456128,0,0,74.456128,-744.36821,-744.56128)">
    <g transform="translate(10,10)">
      <path
        fill={fill}
        d="m 19.924,9.45 -5.3,5.3 a 0.8,0.8 0 0 0 1.128,1.128 L 21.05,10.58 v 1.771 a 0.725,0.725 0 0 0 1.45,0 V 8.724 A 0.725,0.725 0 0 0 21.776,8 h -3.627 a 0.725,0.725 0 0 0 0,1.45 z M 22.5,16.7 v 3.993 A 1.716,1.716 0 0 1 20.893,22.5 H 9.607 A 1.717,1.717 0 0 1 8,20.693 V 9.807 A 1.716,1.716 0 0 1 9.607,8 H 13.8 a 0.725,0.725 0 0 1 0,1.45 H 9.863 A 0.451,0.451 0 0 0 9.45,9.934 V 20.566 A 0.456,0.456 0 0 0 9.863,21.05 H 20.637 A 0.451,0.451 0 0 0 21.05,20.566 V 16.7 a 0.725,0.725 0 1 1 1.45,0 z"
        transform="translate(-8,-8)"
        id="path30"
      />
    </g>
  </g>
);
